import { createBrowserRouter, Navigate } from "react-router-dom";
import PaymentFailedPage from "./common/PaymentFailedPage";

const paymentFailedRoutes = createBrowserRouter([
  {
    path: 'transaction',
    element: undefined,
    children: [
      { path: 'error', element: <PaymentFailedPage />, index: true },
    ]
  },
  {
    path: '*',
    element: <Navigate to='/transaction/error' />
  }
]);

export default paymentFailedRoutes;